import React, { useState, useEffect, useRef } from 'react';
import axios from '../Axiosinstance';
import {
    TextField,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Container,
    Grid,
    Paper,
    Box,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    Typography,
    CircularProgress,
} from '@mui/material';
import Header from "../components/Header";
import FinHeader from '../Finance/Fheader';
import { useNavigate } from 'react-router-dom';

import FilterListIcon from '@mui/icons-material/FilterList';
import ClearIcon from '@mui/icons-material/Clear';
import DownloadIcon from '@mui/icons-material/Download';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { buttonBackgroundColor } from '../common';

function RegistrationList() {
    const [data, setData] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage] = useState(10);
    const [nric, setNric] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [courseType, setCourseType] = useState('');
    const [registrationType, setRegistrationType] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [totalPage, setTotalPage] = useState('');
    const [isDownloading, setIsDownloading] = useState(false);

    const tableContainerRef = useRef(null);

    const buildQueryParams = () => {
        let params = {
            page,
            size: rowsPerPage,
        };

        if (nric) params.nric = nric;
        if (fromDate) params.fromDate = fromDate;
        if (toDate) params.toDate = toDate;
        if (courseType) params.courseType = courseType;
        if (registrationType) params.registrationType = registrationType;

        return params;
    };

    const fetchRegistrationData = async () => {
        if (isLoading || !hasMore) return;

        setIsLoading(true);
        try {

            const response = await axios.get('/registrationadvances/log', {
                params: buildQueryParams(),
            });
            const { content, totalPages } = response.data;

            setData((prevData) => (page === 0 ? content : [...prevData, ...content]));
            setTotalPage(totalPages);
            setHasMore(page + 1 < totalPages); // Check if more pages exist
        } catch (error) {
            console.error('Error fetching registration data:', error);
        } finally {
            setIsLoading(false);
        }
    };


    const handleClearFilters = () => {
        setNric('');
        setFromDate('');
        setToDate('');
        setCourseType('');
        setRegistrationType('');
        setPage(0);
        setData([]);
        setHasMore(true);
        if (page === 0) {

            fetchRegistrationData();
        }
    };

    const handleFilterSubmit = () => {
        setPage(0);
        setData([]);
        setHasMore(true);
        if (page === 0) {

            fetchRegistrationData();
        }
    };


    const debounce = (func, delay) => {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), delay);
        };
    };

    const debouncedHandleScroll = debounce(() => {
        const scrollPosition = window.scrollY + window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;

        if (documentHeight - scrollPosition <= 10 && !isLoading && hasMore) {
            setPage((prevPage) => prevPage + 1);
        }
    }, 200);

    // useEffect(() => {
    //     window.addEventListener('scroll', debouncedHandleScroll);
    //     return () => window.removeEventListener('scroll', debouncedHandleScroll);
    // }, [isLoading, hasMore]);



    useEffect(() => {
        const container = tableContainerRef.current;
        if (!container) return;
    
        const handleScroll = () => {
            const scrollPosition = container.scrollTop + container.clientHeight;
            const scrollHeight = container.scrollHeight;
    
            if (scrollHeight - scrollPosition <= 50 && !isLoading && hasMore) {
                setPage((prevPage) => prevPage + 1);
            }
        };
    
        container.addEventListener('scroll', handleScroll);
        return () => container.removeEventListener('scroll', handleScroll);
    }, [isLoading, hasMore]);

    
    useEffect(() => {
        fetchRegistrationData();
    }, [page]);

    // useEffect(() => {
    //     window.addEventListener('scroll', debouncedHandleScroll);
    //     return () => {
    //         window.removeEventListener('scroll', debouncedHandleScroll);
    //     };
    // }, [isLoading, hasMore]);

    const downloadExcel = async () => {
        try {
            setIsDownloading(true); // Start the loader
            // Create an empty object to store query parameters
            const params = {};

            // Conditionally add parameters only if they have values
            if (nric) params.nric = nric;
            if (fromDate) params.fromDate = fromDate;
            if (toDate) params.toDate = toDate;
            if (courseType) params.courseType = courseType;
            if (registrationType) params.registrationType = registrationType;

            // Make the API request with only the filled parameters
            const response = await axios.get('/registrationadvances/download', {
                params, // Only include parameters with values
                responseType: 'blob', // Ensure the response is handled as a binary file
            });

            // Create a Blob from the response data
            const file = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

            // Get the current date and time
            const now = new Date();

            // Format the date as ddmmyyyy and time as HHmm
            const formattedDate = now.toLocaleDateString('en-GB').split('/').reverse().join('');
            const formattedTime = now.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }).replace(':', '');

            // Create the file name with the formatted date and time
            const fileName = `Payment_Summary_${formattedDate}_${formattedTime}.xlsx`;

            // Create a link element to download the file
            const link = document.createElement('a');
            link.href = URL.createObjectURL(file);
            link.download = fileName; // Set the dynamic file name
            link.click(); // Trigger the download
        } catch (error) {
            console.error('Error downloading Excel file:', error);
        } finally {
            setIsDownloading(false); // Stop the loader
        }
    };

    const maskNRIC_FIN = (value) => {
        if (!value) return "";
        let masked = value.slice(0, -4).replace(/\w/g, "*"); // Replace all but last 4 characters with '*'
        return masked + value.slice(-4); // Append the last 4 characters
    };

    const usertype = localStorage.getItem("usertype")


    return (
        <>
            <div>
                {usertype === '3' || usertype === '4' ? (
                    <Header />
                ) : usertype === '6' ? (
                    <FinHeader />
                ) : (

                    null
                )}
            </div>

            <Container style={{ paddingBottom: '20px' }}>

                <Typography variant="h4" gutterBottom align="center" sx={{ color: 'primary.main', marginTop: '-12px' }}>

                    PAYMENT SUMMARY REPORT
                </Typography>
                <Box
                    sx={{
                        position: 'fixed', // Keeps it in place
                        top: '100px', // Fixed distance from the bottom
                        left: '20px', // Fixed distance from the right
                        zIndex: 1000 // Ensures it's above other content
                    }}
                >

                </Box>
                <Box my={2}>
                    <Paper elevation={3} style={{ padding: 20 }}>
                        <Grid container spacing={3} justifyContent="center">
                            <Grid item xs={12} md={2}>
                                <TextField
                                    label="Search by NRIC"
                                    variant="outlined"
                                    fullWidth
                                    value={nric}
                                    onChange={(e) => setNric(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12} md={2.5}>
                                <TextField
                                    label="From Date"
                                    type="date"
                                    variant="outlined"
                                    fullWidth
                                    value={fromDate}
                                    onChange={(e) => setFromDate(e.target.value)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={2.5}>
                                <TextField
                                    label="To Date"
                                    type="date"
                                    variant="outlined"
                                    fullWidth
                                    value={toDate}
                                    onChange={(e) => setToDate(e.target.value)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel>Course Type</InputLabel>
                                    <Select
                                        value={courseType}
                                        onChange={(e) => setCourseType(e.target.value)}
                                        label="Course Type"
                                    >
                                        <MenuItem value="CourseFee">Course Fee</MenuItem>
                                        <MenuItem value="RegistrationFee">Registration Fee</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={2.5}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel>Registration Type</InputLabel>
                                    <Select
                                        value={registrationType}
                                        onChange={(e) => setRegistrationType(e.target.value)}
                                        label="Registration Type"
                                    >
                                        <MenuItem value="diploma">Diploma</MenuItem>
                                        <MenuItem value="advance_diploma">Advance Diploma</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Box display="flex" justifyContent="center" my={2}>
                            <Grid container spacing={1} justifyContent="center">
                                <Grid item>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleFilterSubmit}
                                        startIcon={<FilterListIcon />}
                                        style={{backgroundColor: buttonBackgroundColor, color:'white'}}
                                    >
                                        Apply Filters
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        variant="outlined"
                                        color="secondary"
                                        onClick={handleClearFilters}
                                        startIcon={<ClearIcon />}
                                    >
                                        Clear Filters
                                    </Button>
                                </Grid>

                                <Grid item>
                                    <Button
                                        variant="contained"
                                        color="success"
                                        onClick={downloadExcel}
                                        startIcon={isDownloading ? <CircularProgress size={24} color="inherit" /> : <DownloadIcon />}
                                        sx={{
                                            backgroundColor: '#4CAF50',
                                            '&:hover': {
                                                backgroundColor: '#45a049',
                                            },
                                            textTransform: 'none',
                                            fontWeight: 'bold',
                                        }}
                                        disabled={isDownloading} // Disable button while downloading
                                    >
                                        {isDownloading ? 'Downloading...' : 'Download Excel'}
                                    </Button>
                                </Grid>

                            </Grid>
                        </Box>
                    </Paper>
                </Box>

                <TableContainer
    component={Paper}
    ref={tableContainerRef}
    style={{ marginTop: 20, maxHeight: '500px', overflowY: 'auto' }}
>
    <Table>
        <TableHead>
        <TableRow>
                <TableCell sx={{ position: 'sticky', top: 0, backgroundColor: 'grey.300', zIndex: 1   , fontWeight: 'bold' }}>S.no</TableCell>
                <TableCell sx={{ position: 'sticky', top: 0, backgroundColor: 'grey.300', zIndex: 1 , fontWeight: 'bold' }}>Name</TableCell>
                <TableCell sx={{ position: 'sticky', top: 0, backgroundColor: 'grey.300', zIndex: 1 , fontWeight: 'bold' }}>NRIC/FIN</TableCell>
                <TableCell sx={{ position: 'sticky', top: 0, backgroundColor: 'grey.300', zIndex: 1 , fontWeight: 'bold' }}>Payment Date</TableCell>
                <TableCell sx={{ position: 'sticky', top: 0, backgroundColor: 'grey.300', zIndex: 1 , fontWeight: 'bold' }}>Invoice number</TableCell>
                <TableCell sx={{ position: 'sticky', top: 0, backgroundColor: 'grey.300', zIndex: 1 , fontWeight: 'bold' }}>Department</TableCell>
                <TableCell sx={{ position: 'sticky', top: 0, backgroundColor: 'grey.300', zIndex: 1 , fontWeight: 'bold' }}>Payment Type</TableCell>
                <TableCell sx={{ position: 'sticky', top: 0, backgroundColor: 'grey.300', zIndex: 1 , fontWeight: 'bold' }}>Amount (excluding gst) ($)</TableCell>
                <TableCell sx={{ position: 'sticky', top: 0, backgroundColor: 'grey.300', zIndex: 1 , fontWeight: 'bold' }}>GST (9%) ($)</TableCell>
                <TableCell sx={{ position: 'sticky', top: 0, backgroundColor: 'grey.300', zIndex: 1 , fontWeight: 'bold' }}>Amount inclusive of GST ($)</TableCell>
            </TableRow>
        </TableHead>

                        <TableBody>
                            {data.map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>{row.name.toUpperCase()}</TableCell>
                                    {/* <TableCell>{row.nric}</TableCell> */}
                                    <TableCell>{(row.nric)}</TableCell>
                                    <TableCell>
                                        {new Date(row.sessionDate).toLocaleDateString('en-GB')}
                                    </TableCell>
                                    <TableCell>
                                        {row.courseType === 'RegistrationFee'
                                            ? `JA${new Date(row.sessionDate).getFullYear().toString().slice(-2)}-${String(row.sequenceNumber).padStart(4, '0')}-${row.nric}-R`
                                            : row.courseType === 'CourseFee'
                                                ? `JAO/CF-${new Date(row.sessionDate).getFullYear().toString().slice(-2)}-${String(row.sequenceNumber).padStart(4, '0')}`
                                                : ''
                                        }
                                    </TableCell>
                                    <TableCell>{row.course}</TableCell>
                                    {/* <TableCell>{row.courseType}</TableCell> */}
                                    <TableCell>{row.type}</TableCell>
                                    {/* <TableCell>{((row.amount) - (row.amount * 0.09)).toFixed(2)}</TableCell> */}
                                    <TableCell>{(row.amount / 1.09).toFixed(2)}</TableCell>
                                    <TableCell>{((row.amount) - (row.amount / 1.09)).toFixed(2)}</TableCell>
                                    <TableCell>{(row.amount).toFixed(2)}</TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                {isLoading && (
                    <Box display="flex" justifyContent="center" my={2}>
                        <CircularProgress />
                    </Box>
                )}

                {!hasMore && !isLoading && (
                    <Typography align="center" my={2}>
                        No more data to load.
                    </Typography>
                )}
            </Container>
        </>
    );
}

export default RegistrationList;
